/**
 * Park / Recall summaries + conflict chooser — plan/28.
 * No line merge: cashier picks one option.
 */

export type ParkConflictSide = {
  key: string;
  /** Terminal or "This cart" */
  title: string;
  itemCount: number;
  /** Display money already formatted (e.g. 115.00) */
  dueAmount: string;
};

export function cartItemCount(
  lines: readonly { qty: number }[],
): number {
  return lines.reduce((n, l) => n + (Number.isFinite(l.qty) ? l.qty : 0), 0);
}

export function buildParkConflictOptions(args: {
  current: ParkConflictSide;
  incoming: ParkConflictSide;
}): [ParkConflictSide, ParkConflictSide] {
  return [args.current, args.incoming];
}
